module.exports = __webpack_public_path__ + "img/logo-roumu-color-set.4ee9b48f.svg";